module.exports = __webpack_public_path__ + "img/htyz2.1bb54fac.png";